import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from 'src/app/core/services/base-http.service';
import { environment } from 'src/environments/environment';
import { CartaPorteView } from '../consult-traceability/view-waybill-traceability/view-waybill-traceability.component';
import { CartaPorte } from 'src/app/core/models/carta-porte/carta-porte';
import { CartaPorteBase } from 'src/app/core/models/carta-porte/carta-porte-base';
import { CartaPorteDetalleSaldo } from 'src/app/core/models/carta-porte/carta-porte-detalle-saldo';
import { CartaPorteExtendedTotalesResponseDto } from './classes/carta-porte-extended-totales-response-dto';
import { CartaPorteExtendida } from 'src/app/core/models/carta-porte/carta-porte-extendida';
import { MovimientoUnidadProductiva } from 'src/app/core/models/carta-porte/unidad-productiva-carta-porte';

@Injectable({
	providedIn: 'root'
})
export class WaybillService extends BaseHttpService<
	CartaPorteBase,
	CartaPorte
> {
	constructor(http: HttpClient) {
		super(http);
		this.url = 'CartaPorte';
		this.baseUrl = environment.apiUrlTrazabilidad;
	}

	getTraza(numeroCTG: string) {
		return this.http.get<CartaPorteView[]>(
			`${this.baseUrl}/${this.url}/Traza/${numeroCTG}`
		);
	}

	getAllExtended(
		filters: any
	): Observable<CartaPorteExtendedTotalesResponseDto> {
		const queryParams =
			filters != undefined ? this.setQueryParams(filters) : undefined;
		return this.http.get<CartaPorteExtendedTotalesResponseDto>(
			`${this.baseUrl}/CartaPorteExtended${queryParams ?? ''}`
		);
	}

	getAllExtendedUnpaginated(
		filters: any
	): Observable<{ data: CartaPorteExtendida[] }> {
		const queryParams =
			filters != undefined ? this.setQueryParams(filters) : undefined;
		return this.http.get<{ data: CartaPorteExtendida[] }>(
			`${this.baseUrl}/CartaPorteExtendedUnpaginated${queryParams ?? ''}`
		);
	}

	getDetalleSaldo(idCartaPorte: number) {
		return this.http.get<CartaPorteDetalleSaldo[]>(
			`${this.baseUrl}/${this.url}/GetDetalleSaldo/${idCartaPorte}`
		);
	}

	getCartaPorteUP(
		idCartaPorte: number
	): Observable<MovimientoUnidadProductiva[]> {
		return this.http.get<MovimientoUnidadProductiva[]>(
			`${this.baseUrl}/CartaPorteUP/${idCartaPorte}`
		);
	}
}
